import { getModuleRoutes } from "@brightinsight/bi-web-dms-modules";
import { RouteConstants } from "./constants/RouteConstants";
import { Feature, configureObj } from "./../../common/@types";

// Define the PatientDetail module configuration function
const TeamsManagement = (applnFeature: Feature) => {
  // Retrieve module routes and menu items list based on the application feature and route constants
  const { moduleRoutes, menuItemsList }: configureObj = getModuleRoutes(
    applnFeature,
    RouteConstants
  );

  // Create the module configuration object
  const moduleConfig = {
    configureObj: {
      routes: moduleRoutes,
      menuOptions: menuItemsList,
    },
  };

  // Return the module configuration
  return moduleConfig;
};

// Export the Patients module
export { TeamsManagement };
